import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeFromCart, clearCart } from "../store/cartSlice";
import { MdDeleteOutline } from "react-icons/md";
import CartTable from "../components/Cart/CartTable";


export default function CartPage() {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.cart.items);

  const [selectedItems, setSelectedItems] = useState([]);

  const handleOrder = () => {
    dispatch(clearCart());
  };


  const handleRemove = (id, weight) => {
    dispatch(removeFromCart({ id, weight }));
    setSelectedItems((prev) => prev.filter((k) => k !== `${id}-${weight}`));
  };

  const handleRemoveSelected = () => {
    selectedItems.forEach((key) => {
      const [id, weight] = key.split("-");
      dispatch(removeFromCart({ id, weight }));
    });
    setSelectedItems([]);
  };


  const whatsappNumber = "989155838178";
  const createWhatsappMessage = () => {
    if (items.length === 0) return "";
    let message = "سلام،%0Aمن می‌خواهم این محصولات را سفارش دهم:%0A%0A";
    items.forEach((item, i) => {
      const isPowder = item.id.includes("Powder");

      const weight = isPowder? `گرم` : 'تعداد';

      message += `${i + 1}. ${item.weight} ,قهوه ${item.title} - ${weight}: ${item.quantity}%0A`;
    });
    message += "%0Aممنون می‌شوم راهنمایی کنید.";
    return message;
  };
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${createWhatsappMessage()}`;

  if (items.length === 0)
    return (
      <div className="h-96 flex flex-col justify-center items-center py-6 px-3">
        <p className="text-xl mb-6">سبد خرید شما خالی است.</p>
        <a
          href="/home"
          className="inline-block bg-amber-600 text-white px-6 py-3 rounded-lg"
        >
          بازگشت به صفحه محصولات
        </a>
      </div>
    );

  return (
    <div className="max-w-5xl mx-auto mt-24 p-6">
      <div className="flex justify-between mb-4">
        <h2 className="text-2xl font-bold">سبد خرید شما</h2>
        {selectedItems.length > 0 && (
          <button
            onClick={handleRemoveSelected}
            className="flex items-center gap-1 text-red-600 hover:text-red-800 transition"
          >
            <MdDeleteOutline size={20} /> حذف انتخاب‌شده‌ها
          </button>
        )}
      </div>

      <div className="overflow-x-auto border rounded-lg">
        <CartTable items={items} handleRemove={handleRemove} />
      </div>

      <div className="mt-6 flex justify-between items-center">
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleOrder}
          className="cursor-pointer bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition text-sm"
        >
          ثبت سفارش از طریق واتساپ
        </a>
      </div>
    </div>
  );
}

